"use strict";

exports.__esModule = true;
exports.THEME_NAME = exports.SandvikTheme = exports.BaseTheme = void 0;
exports.getThemeByName = getThemeByName;
exports.getThemeWrapperByName = getThemeWrapperByName;
var BaseTheme = _interopRequireWildcard(require("./base"));
exports.BaseTheme = BaseTheme;
var SandvikTheme = _interopRequireWildcard(require("./sandvik"));
exports.SandvikTheme = SandvikTheme;
var SandvikV2Theme = _interopRequireWildcard(require("./sandvik-v2"));
var VimanaTheme = _interopRequireWildcard(require("./vimana"));
var LmwTheme = _interopRequireWildcard(require("./lmw"));
var HclTheme = _interopRequireWildcard(require("./hcl"));
var dmgmoriTheme = _interopRequireWildcard(require("./dmgmori"));
var caiTheme = _interopRequireWildcard(require("./cai"));
var _SandvikWrapper = require("./sandvik/SandvikWrapper");
var _SandvikV2Wrapper = require("./sandvik-v2/SandvikV2Wrapper");
var _LmwWrapper = require("./lmw/LmwWrapper");
var _HclWrapper = require("./hcl/HclWrapper");
var _BaseThemeWrapper = require("./base/BaseThemeWrapper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var THEME_NAME = exports.THEME_NAME = process.env.VI_THEME || "base";
function getThemeByName(name) {
  if (name === "sandvik") {
    return SandvikTheme;
  }
  if (name === "sandvik-v2") {
    return SandvikV2Theme;
  }
  if (name === "vimana") {
    return VimanaTheme;
  }
  if (name === "lmw") {
    return LmwTheme;
  }
  if (name === "hcl") {
    return HclTheme;
  }
  if (name === "dmgmori") {
    return dmgmoriTheme;
  }
  if (name === "cai") {
    return caiTheme;
  }
  return BaseTheme;
}
function getThemeWrapperByName(name) {
  if (name === "sandvik") {
    return _SandvikWrapper.SandvikWrapper;
  }
  if (name === "sandvik-v2") {
    return _SandvikV2Wrapper.SandvikV2Wrapper;
  }
  if (name === "lmw") {
    return _LmwWrapper.LmwWrapper;
  }
  if (name === "hcl") {
    return _HclWrapper.HclWrapper;
  }
  return _BaseThemeWrapper.BaseWrapper;
}